import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MostLeastSoldItemData } from 'src/app/shared/most-least-sold-tableData';
import { DashboardService } from 'src/services/dashboard.service';

@Component({
  selector: 'least-sold-items',
  templateUrl: './least-sold-items.component.html',
  styleUrls: ['./least-sold-items.component.css']
})
export class LeastSoldItemsComponent implements OnInit {

  data: { name: string, qtySold: number }[] = [];
  passData: any[] = []
  columnName: string[] = ['ItemName', 'SoldQty'];
  dataSource!: MatTableDataSource<undefined> | any;

  constructor(private readonly dash: DashboardService) { }

  ngOnInit(): void {
    this.dash.getDetailsOfSoldItem().subscribe(response => {
      this.data = MostLeastSoldItemData.generateDataForTable(response.monthly);
      this.data.sort((a, b) => a.qtySold - b.qtySold);
      let leastSoldtableData = this.data.slice(0, 10);
      this.passData = [this.columnName, leastSoldtableData]
      this.dataSource = new MatTableDataSource(this.passData[1]);
    })
  }

}
